import { Box, Grid, Skeleton } from "@mui/material";

function MetricCardSkeleton() {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #e8ecf0",
        minHeight: 110,
        bgcolor: "#fff",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.5 }}>
        <Skeleton variant="text" width={60} height={16} />
        <Skeleton variant="rounded" width={32} height={32} />
      </Box>
      <Skeleton variant="text" width="45%" height={32} />
      <Skeleton variant="text" width="70%" height={14} sx={{ mt: 1 }} />
    </Box>
  );
}

export default function SubscriptionOverviewSkeleton() {
  return (
    <Box>
      <Grid container spacing={1.5} sx={{ mb: 2.5 }}>
        {Array.from({ length: 6 }).map((_, i) => (
          <Grid item xs={12} sm={4} md={2} key={i}>
            <MetricCardSkeleton />
          </Grid>
        ))}
      </Grid>
      <Skeleton variant="rounded" height={320} sx={{ borderRadius: 2 }} />
    </Box>
  );
}
